export const DEFAULT_REBUY_TIME_IN_SECONDS = 45;
export const DEFAULT_ROUND_BREAK_FINAL_REBUY_TIME_IN_SECONDS = 0;
export const DEFAULT_ELIMINATION_HANG_TIME_IN_SECONDS = 120;
export const DEFAULT_LATE_REGISTRATION_TIME_IN_MINUTES = 30;
export const DEFAULT_TIMEOUT_IN_SECONDS = 30;
export const DEFAULT_MIN_TABLE_SIZE_BEFORE_REBALANCE = 5;
export const DEFAULT_ENABLE_PERFORMANT_REBALANCES = false;
export const DEFAULT_ENABLE_PLAYER_WELCOME_VIDEOS = true;
export const DEFAULT_ENABLE_AUTOMATION = false;
